// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"styles_inputBox__fN4tY","inputLabel":"styles_inputLabel__PWEjp","title":"styles_title__idC0M","searchArea":"styles_searchArea__cwDVa","footer":"styles_footer__G5ENo"};